export enum SortOrder {
  NONE = 0,
  ASC = -1,
  DESC = 1,
}

// Uncomment PTO_MANAGER when enabled, as this affects the behaviour of
// how notifications are filtered in ProfileBubble
export const NotificationTypes = {
  TIMESHEET: 'TIMESHEET',
  TIMESHEET_MANAGER: 'TIMESHEET_MANAGER',
  PTO_MANAGER: 'PTO_MANAGER',
  DYNAMIC: 'DYNAMIC',
  BIRTHDAY: 'BIRTHDAY',
  TRAVEL_MANAGER: 'TRAVEL_MANAGER',
  TRAVEL_OPS: 'TRAVEL_OPS',
  UPCOMING_REVIEW: 'UPCOMING_REVIEW',
  ASSIGNMENT_APPROVAL: 'ASSIGNMENT_APPROVAL',
  PROJECTS_APPROVAL_COUNT: 'PROJECTS_APPROVAL_COUNT',
  CLIENTS_APPROVAL_COUNT: 'CLIENTS_APPROVAL_COUNT',
  ACTION_ITEM: 'ACTION_ITEM',
  IT_COMPLIANCE: 'IT_COMPLIANCE',
  WORK_HISTORY: 'WORK_HISTORY',
};

export const NotificationPriorities = {
  HIGH: 3,
  NORMAL: 2,
  LOW: 1,
};

export const CsvExport = {
  BOM: '\uFEFF', //prepend to CSV data to force UTF-8
  CSV_TYPE: 'text/csv;charset=utf-8',
  CSV_EXTENSION: '.csv',
};

// Public placeholder served when a user has no profile photo (mirrors the backend default in
// personPhotoUrlCreator). Used as the onError fallback for profile <img>s so a failed or expired
// signed S3 URL degrades to this instead of the browser's broken-image icon. See KGP-1164.
export const NO_PROFILE_IMG_URL = 'https://portal-assets-prod.s3.amazonaws.com/uilib/no-profile-img.jpg';
